import { createActionConst } from '../../../utils/action.utils';

const SESSION_NAMESPACE = 'SESSION';

export const STORE_SESSION = createActionConst(SESSION_NAMESPACE, 'STORE_SESSION');
export const CLEAR_SESSION = createActionConst(SESSION_NAMESPACE, 'CLEAR_SESSION');
